module.exports = __webpack_public_path__ + "img/VoyageLA-SuperOK-2.a132e2a2.png";